module.exports = __webpack_public_path__ + "img/client-putin_tw.8c15d10d.svg";